"use client";

import { c as _c } from "react/compiler-runtime";
import CreateDropMetadataItems from "@/components/drops/create/utils/metadata/CreateDropMetadataItems";
import type { DropMetadata } from "@/entities/IDrop";
import { useRef, useState } from "react";
export default function CreateDropFullDesktopMetadata(t0) {
  const $ = _c(33);
  const {
    metadata,
    onMetadataEdit,
    onMetadataRemove,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const [key, setKey] = useState(null);
  const [value, setValue] = useState(null);
  const metadataKeyRef = useRef(null);
  let t2;
  if ($[0] !== disabled || $[1] !== key || $[2] !== onMetadataEdit || $[3] !== value) {
    t2 = e => {
      e.preventDefault();
      if (disabled) {
        return;
      }
      if (key && value) {
        onMetadataEdit({
          data_key: key,
          data_value: value
        });
        setKey(null);
        setValue(null);
        metadataKeyRef.current?.focus();
      }
    };
    $[0] = disabled;
    $[1] = key;
    $[2] = onMetadataEdit;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onSubmit = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <label htmlFor="metadata-form" className="tw-block tw-text-sm tw-font-medium tw-text-iron-300">Metadata</label>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = key ?? "";
  let t5;
  if ($[6] !== disabled) {
    t5 = e_0 => {
      if (!disabled) {
        setKey(e_0.target.value);
      }
    };
    $[6] = disabled;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== disabled || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="tw-w-full"><input ref={metadataKeyRef} type="text" placeholder="Category" value={t4} onChange={t5} disabled={disabled} maxLength={100} className="tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-py-2.5 tw-pr-3 tw-text-md tw-font-normal tw-leading-6 tw-text-iron-50 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-400 hover:tw-ring-iron-700 focus:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400" /></div>;
    $[8] = disabled;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = value ?? "";
  let t8;
  if ($[12] !== disabled) {
    t8 = e_1 => {
      if (!disabled) {
        setValue(e_1.target.value);
      }
    };
    $[12] = disabled;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== disabled || $[15] !== t7 || $[16] !== t8) {
    t9 = <div className="tw-w-full"><input type="text" placeholder="Value" value={t7} onChange={t8} disabled={disabled} maxLength={500} className="tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-py-2.5 tw-pr-3 tw-text-md tw-font-normal tw-leading-6 tw-text-iron-50 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-400 hover:tw-ring-iron-700 focus:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400" /></div>;
    $[14] = disabled;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <svg className="tw-flex tw-h-5 tw-w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== disabled) {
    t11 = <button type="submit" aria-label="Add metadata" title="Add metadata" disabled={disabled} className="tw-inline-flex tw-items-center tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-px-2.5 tw-py-2.5 tw-text-iron-300 tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-iron-700 hover:tw-text-iron-200 focus:tw-z-10 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400">{t10}</button>;
    $[19] = disabled;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== onSubmit || $[22] !== t11 || $[23] !== t6 || $[24] !== t9) {
    t12 = <form id="metadata-form" onSubmit={onSubmit} className="tw-mt-1.5 tw-flex tw-w-full tw-items-center tw-gap-x-3">{t6}{t9}{t11}</form>;
    $[21] = onSubmit;
    $[22] = t11;
    $[23] = t6;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== disabled || $[27] !== metadata || $[28] !== onMetadataRemove) {
    t13 = <CreateDropMetadataItems items={metadata} onMetadataRemove={onMetadataRemove} disabled={disabled} />;
    $[26] = disabled;
    $[27] = metadata;
    $[28] = onMetadataRemove;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <div>{t3}{t12}{t13}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}